import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { baseExtraReducers, baseGetData, baseInitialState, baseReducers } from 'helpers/slice.helper';
import { APP_URLS } from 'constants/url.constant';

const name = 'companyDetailMessage';

export const getData = createAsyncThunk(
    `${name}/getData`,
    async props => await baseGetData({ url: APP_URLS.MESSAGE_THREADS, ...props })
);

export const defaultFilters = {};

const companyDetailMessageSlice = createSlice({
    name,
    initialState: {
        ...baseInitialState,
        filters: defaultFilters,
        sorter: {
            //field: 'created_at',
            //order: 'descend',
        },
    },
    reducers: baseReducers,
    extraReducers: baseExtraReducers(getData),
});

export const { setLoading, setData, setPagination, setFilters, setSorter, setHideColumns, setSelection } =
    companyDetailMessageSlice.actions;

export default companyDetailMessageSlice.reducer;
